import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import './Inbox.css';
import { Toast } from "primereact/toast";
import { Compose } from "./Compose";
import { Button } from "primereact/button";
import { Requirement } from "./Requirement";
import { EmptyRequirement } from "../requirement/EmptyRequirement";
import { PocRequirement } from "./PocRequirement";
import { Interview_Process, IRequirementMast, Job_Type, Mode_Of_Req, Req_Term } from "../../models/RequirementMast";
import { IClientContactPerson } from "../../models/ClientContactPerson";
import { EmptyClientContactPerson } from "../clientContactPerson/EmptyClientContactPerson";
import { ClientContact } from "./ClientContact";
import { OtherSource } from "./OtherSource";

interface IFolder {
  name: string,
  displayName: string,
  count: number,
  unread: number
}
export interface IEmail {
  id: number,
  subject: string,
  from: string,
  fromName: string,
  fromEmail: string,
  date: string,
  snippet?: string,
  body?: string,
  to?: string[],
  cc?: string[],
  bcc?: string[],
  isRead: boolean
}
export interface IJobDto {
  jobTitle: string;
  position: number;
  duration: string;
  rate: number;
  endClient: string;
  visa: string[];
  specialConstraints: string[];
  industry: string;
  skillCategory: string;
  subSkillCategory?: string;
  jobTerm: Req_Term;
  jobType: Job_Type;
  interviewProcess: Interview_Process;
  skills: string;
  state: string;
  city: string;
  jobDescription: string;
}

interface IPostReqForm {
  open: boolean,
  singleData: IRequirementMast,
  isPoc: boolean
}

export function Inbox() {
  const pageSize = 20;
  const [folders, setFolders] = useState<IFolder[]>([]);
  const [emails, setEmails] = useState<Record<string, IEmail[] | undefined>>({ 'INBOX': undefined });
  const [selectedEmail, setSelectedEmail] = useState<IEmail>();
  const [fp, setFp] = useState<{ folder: string, page: Record<string, number | undefined> }>({ folder: 'INBOX', page: { 'INBOX': 1 } });
  const [loadingEmails, setLoadingEmails] = useState(false);
  const [loadingMail, setLoadingMail] = useState(false);
  const [composingReq, setComposingReq] = useState(false);
  const [composingReqFromO, setComposingReqFromO] = useState(false);
  const toast = useRef<Toast>(null);

  const [compose, setCompose] = useState({ singleData: {}, open: false } as { singleData: { id?: number, subject?: string, body?: string, to?: string, cc?: string }, open: boolean });
  const hideCompose = () => {
    setCompose({ singleData: {}, open: false });
  }
  const [req, setReq] = useState({ singleData: {}, open: false, isPoc: false } as IPostReqForm);
  const hideReq = () => {
    setReq({ singleData: {}, open: false, isPoc: false });
  }
  const [client, setClient] = useState({ singleData: EmptyClientContactPerson, open: false } as { singleData: IClientContactPerson, open: boolean });
  const hideClient = () => {
    setClient({ singleData: EmptyClientContactPerson, open: false });
  }
  const [otherSource, setOtherSource] = useState(false);

  const onSend = (data: IEmail) => {
    console.log(data);
    const _data = { ...data, body: undefined };
    setEmails(prev => {
      const sentMails = prev['Sent'];
      if (sentMails) {
        return { ...prev, Sent: [...sentMails, _data] }
      } else return { ...prev, Sent: [_data] };
    });
    setFolders(prev => {
      const sentMailsCount = prev.find(f => f.name === 'Sent')?.count ?? 0;
      return prev.map(f => f.name === 'Sent' ? { ...f, count: sentMailsCount + 1 } : f);
    });
  }

  useEffect(() => { fetchFolders() }, []);
  useEffect(() => {
    const pageNum = fp.page[fp.folder] ?? 1;
    if (!emails[fp.folder]) {
      fetchEmails(1, fp.folder);
      return;
    }
    const alreadyLoaded = emails[fp.folder]?.length ?? 0;
    const expectedCount = Math.min(pageNum * pageSize, folders.find(f => f.name === fp.folder)?.count ?? 0);
    if (alreadyLoaded < expectedCount) {
      fetchEmails(pageNum, fp.folder);
    }
  }, [fp]);

  const fetchFolders = async () => {
    const response = await Fetch('email/folders', 'GET', null, null, toast);
    if (response) {
      const data = await response.json();
      setFolders(data);
    }
  }

  const fetchEmails = async (pageNumber: number, folderName: string) => {
    setLoadingEmails(true);
    const response = await Fetch(`email/folder/${folderName}`, 'GET', null, `pageNumber=${pageNumber}&pageSize=${pageSize}`, null);
    if (response) {
      const data: IEmail[] = await response.json();
      console.log(data);
      setEmails((prev) => ({ ...prev, [folderName]: [...prev[folderName] ?? [], ...data] }));
    }
    setLoadingEmails(false);
  }

  const handleScroll = (e: any) => {
    if (loadingEmails) return;
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    if (scrollHeight - scrollTop <= clientHeight + 1) {
      const foldersEmail = [...emails[fp.folder] ?? []];
      const maxCount = folders.find(f => f.name === fp.folder)?.count ?? 0;

      if (foldersEmail.length < maxCount) {
        setFp(prev => {
          const folder = prev.folder;
          const page = prev.page;
          const PageNum = (page[folder] ?? 1) + 1;
          console.log('scroll triggered!', folder, PageNum);
          return { ...prev, page: { ...page, [folder]: PageNum } };
        });
      }
    }
  };


  const openEmail = async (id: number) => {
    if (loadingMail) {
      toast?.current?.show({ severity: 'info', detail: 'Wait before trying again...', life: 3000 });
      return;
    }
    setLoadingMail(true);
    const _selected_Email = emails[fp.folder]?.find(f => f.id === id);
    const markRead = _selected_Email ? !_selected_Email.isRead : false;
    setSelectedEmail(_selected_Email);
    const response = await Fetch(`email/read/${fp.folder}/${id}`, 'GET', null, `markRead=${markRead}`, null);
    if (response) {
      const data: IEmail = await response.json();
      console.log(data);
      setEmails(prev => {
        const f_mails = prev[fp.folder];
        if (f_mails) {
          const _f_mails = f_mails.map(m => m.id === id ? { ...m, isRead: true } : m);
          return { ...prev, [fp.folder]: _f_mails };
        } else return prev;
      });
      setSelectedEmail(data);
    }
    setLoadingMail(false);
  };

  const formatOutlookDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const now = new Date();

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const isSameDay = (a: Date, b: Date) =>
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate();

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    if (isSameDay(date, now)) {
      return date.toLocaleTimeString([],
        { hour: "numeric", minute: "2-digit", hour12: true, timeZone: userTimeZone, });
    }

    if (isSameDay(date, yesterday)) {
      return "Yesterday";
    }

    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - now.getDay());

    if (date > startOfWeek) {
      return date.toLocaleDateString([],
        { weekday: "short", timeZone: userTimeZone, });
    }

    if (date.getFullYear() === now.getFullYear()) {
      return date.toLocaleDateString([],
        { month: "short", day: "numeric", timeZone: userTimeZone, });
    }

    return date.toLocaleDateString([],
      { month: "short", day: "numeric", year: "numeric", timeZone: userTimeZone, });
  };

  const composeReqFromEmailContent = async () => {
    if (composingReq) {
      toast?.current?.show({ severity: 'info', detail: 'Wait before trying again...', life: 3000 });
      return;
    }
    setComposingReq(true);
    if (selectedEmail?.body && selectedEmail.fromEmail) {
      const data = { subject: selectedEmail.subject, body: selectedEmail.body }
      await autoFillReq(data, selectedEmail.id, selectedEmail.fromEmail, selectedEmail.fromName);
    } else {
      toast?.current?.show({ severity: 'info', detail: 'Wait for the email to load', life: 3000 });
    }
    setComposingReq(false);
  }

  const composeReqFromOtherSource = async (_data: { subject: string, body: string }, _email: string) => {
    setComposingReqFromO(true);
    await autoFillReq(_data, 0, _email, '')
    setComposingReqFromO(false);
  }

  async function autoFillReq(_data: { subject: string, body: string }, email_ID: number, fromEmail: string, fromName: string) {
    const res = await Fetch('Sub_Vendor_Contact_Person_Mast/getClientAvailabilityByEmail', 'GET', null, `email_id=${email_ID}&email=${fromEmail}`, toast);
    if (res) {
      const contactPersonDetails: {
        contact_Person_ID: number,
        contact_Person_Name: string,
        contact_Person_EmailID: string,
        vendor_Company_ID: number,
        vendor_Company_Name: string,
        sales_Person_Id: number,
        isMine: boolean,
        message?: string
      } = await res.json();
      console.log(contactPersonDetails);

      if (contactPersonDetails.message === 'Add Client') {
        setClient(prev => ({ open: true, singleData: { ...prev.singleData, contact_Person_EmailID: fromEmail, contact_Person_Name: fromName } }));
        return;
      }

      const _res = await Fetch(`email/job`, 'POST', _data, null, toast);
      if (_res) {
        const data: IJobDto = await _res.json();
        const _state = { state_ID: 0, state_Name: '' };
        const _city = { city_ID: 0, city_Name: '' };
        if (data.state && data.city) {
          const __res = await Fetch(`dropdown/auto_state_city`, 'GET', null, `state=${data.state}&city=${data.city}`, null);
          if (__res) {
            const location: { state_ID: number, state_Name: string, city_ID: number, city_Name: string } = await __res.json();
            _state.state_ID = location.state_ID;
            _state.state_Name = location.state_Name;
            _city.city_ID = location.city_ID;
            _city.city_Name = location.city_Name;
            console.log(location);
          }
        }

        let vendor_type: number = 0;
        if (fromEmail) {
          const r = await Fetch('dropdown/GetVendorTypeFromClientEmail', 'GET', null, `client_email=${fromEmail}`, null);
          if (r) {
            const d: { vendor_Type: number } = await r.json();
            vendor_type = d.vendor_Type;
          }
        }

        setReq({
          open: true, singleData: {
            ...EmptyRequirement,
            email_ID: email_ID,
            req_Job_Title: data.jobTitle,
            req_NoOfPositions: data.position.toString(),
            req_Duration: data.duration,
            req_Rate: data.rate.toString(),
            req_EndClient: data.endClient,
            endClient: { end_Client_Id: 0, end_Client_Name: data.endClient },
            req_Term: data.jobTerm,
            job_Type: data.jobType,
            industry_Name: data.industry,
            req_Category_Name: data.skillCategory,
            req_Sub_Category_Name: data.subSkillCategory,
            reqType: vendor_type,
            req_RequiredSkill: data.skills,
            req_InterviewProcess: data.interviewProcess === Interview_Process.NotMentioned ? Interview_Process.Telephonic : data.interviewProcess,
            visa: data.visa.join(','),
            state: _state,
            city: _city,
            req_JobDescription: data.jobDescription,
            pV_Contact_PersonID_Email: contactPersonDetails.contact_Person_EmailID,
            pV_Contact_PersonID: contactPersonDetails.contact_Person_ID,
            mode_Of_Req: Mode_Of_Req.Mail,
            special_Constraint: data.specialConstraints.join(',')
          }, isPoc: !contactPersonDetails.isMine
        });
        console.log(data);
      }
    }
  }

  return (
    <>
      <div style={{ position: 'fixed', right: 0, marginTop: '-20px', marginRight: '10px' }}>
        <Button disabled={composingReq} className="p-button-sm" loading={composingReqFromO} onClick={() => setOtherSource(true)} label={composingReqFromO ? 'Waiting for response...' : 'Compose from Other Source'} />
      </div>
      <div className="grid email_container">
        <div className="col-1 emails">
          {folders.map((_folder) => (
            <div key={_folder.name} className={`p-2 cursor-pointer ${_folder.name === fp.folder ? 'email_folder_active' : 'email_folder'}`} onClick={() => setFp(prev => ({ ...prev, folder: _folder.name }))}>
              <div className="font-bold">{_folder.displayName}</div>
              <div className="text-sm text-gray-500">{_folder.count}/{_folder.unread}</div>
            </div>
          ))}
          {folders.length > 0 && <Button disabled={composingReq || composingReqFromO} className="mt-2 p-button-sm" onClick={() => setCompose({ singleData: {}, open: true })} label="Send Email" />}
        </div>

        <div className="col-3 emails email_scroll" onScroll={handleScroll}>
          {emails && emails[fp.folder]?.map((mail) => (
            <div key={mail.id} className={`p-2 cursor-pointer grid ${selectedEmail && mail.id === selectedEmail.id ? 'email_active' : 'email'}`} onClick={() => openEmail(mail.id)}>
              <div className="col-9">
                <div className={mail.isRead ? "truncate" : "font-bold truncate"}>{mail.subject}</div>
                <div className="text-sm text-gray-500 truncate">{mail.from}</div>
              </div>
              <div className="col-3 text-sm text-gray-500 px-0">{formatOutlookDate(mail.date)}</div>
            </div>
          ))}
          {emails[fp.folder]?.length === 0 && <p className="text-center p-2">Nothing in {fp.folder}</p>}
          {loadingEmails && <p className="text-center p-2">Loading...</p>}
        </div>

        <div className="col-8">
          {selectedEmail ? (
            <>
              <div style={{ paddingBottom: '5px', borderBottom: '1px solid gray' }}>
                <p className="text-gray-500 my-2">{selectedEmail.from}
                  {selectedEmail.id && <><Button disabled={composingReq || composingReqFromO} className="p-button-sm p-button-link" onClick={() => setCompose({
                    singleData: {
                      id: selectedEmail.id,
                      subject: `RE: ${selectedEmail.subject}`,
                      body: `
                          <br>
                          <br>
                          <br>
                          <hr>
                          From: <span>${selectedEmail.fromName} &lt;${selectedEmail.fromEmail}&gt;</span><br />
                          Sent: <span>${selectedEmail.date}</span><br />
                          To: <span>${selectedEmail.to}</span><br />
                          Subject: <span>${selectedEmail.subject}</span>
                          <blockquote>
                          ${selectedEmail.body}
                          </blockquote>`,
                      to: selectedEmail.fromEmail
                    }, open: true
                  })} label="Reply" />
                    <Button disabled={composingReq || composingReqFromO} className="p-button-sm p-button-link" onClick={() => setCompose({
                      singleData: {
                        id: selectedEmail.id,
                        subject: `RE: ${selectedEmail.subject}`,
                        body: `
                          <br>
                          <br>
                          <br>
                          <hr>
                          From: <span>${selectedEmail.fromName} &lt;${selectedEmail.fromEmail}&gt;</span><br />
                          Sent: <span>${selectedEmail.date}</span><br />
                          To: <span>${selectedEmail.to}</span><br />
                          Subject: <span>${selectedEmail.subject}</span>
                          <blockquote>
                          ${selectedEmail.body}
                          </blockquote>`,
                        to: selectedEmail.fromEmail,
                        cc: selectedEmail.cc?.join(',')
                      }, open: true
                    })} label="Reply All" />
                    <Button disabled={composingReq || composingReqFromO} className="p-button-sm p-button-link" onClick={() => setCompose({
                      singleData: {
                        id: selectedEmail.id,
                        subject: `FW: ${selectedEmail.subject}`,
                        body: `
                          From: <span>${selectedEmail.fromName} &lt;${selectedEmail.fromEmail}&gt;</span><br />
                          Sent: <span>${selectedEmail.date}</span><br />
                          To: <span>${selectedEmail.to}</span><br />
                          Subject: <span>${selectedEmail.subject}</span>
                          ${selectedEmail.body}`,
                      }, open: true
                    })} label="Forward" />
                  </>}</p>
                <h2 className="text-xl font-bold m-0">{selectedEmail.subject} {selectedEmail.body && <Button disabled={composingReqFromO} label={composingReq ? 'Waiting for response...' : 'Compose Requirement'} loading={composingReq} className="p-button-sm p-button-success" onClick={() => composeReqFromEmailContent()} />}</h2>
              </div>
              <div className="mt-3 email_content">
                <iframe title="Email Content"
                  sandbox=""
                  srcDoc={selectedEmail.body ?? 'Loading email content...'}
                  style={{ width: "100%", height: "100%", border: "none" }}
                />
              </div>
            </>
          ) : (
            <p className="font-italic">This functionality is part of a beta(v1.1.0 beta) release and does not represent the final quality.</p>
          )}
        </div>
      </div>
      <Compose onSend={onSend} hideDialog={hideCompose} open={compose.open} singleData={compose.singleData} toast={toast} />
      <Toast ref={toast} />

      {req.isPoc ?
        <PocRequirement singleData={req.singleData} open={req.open && req.isPoc} hideDialog={hideReq} toast={toast} />
        : <Requirement singleData={req.singleData} open={req.open && !req.isPoc} hideDialog={hideReq} toast={toast} />
      }

      <ClientContact singleData={client.singleData} open={client.open} hideDialog={hideClient} toast={toast} onSuccess={composeReqFromEmailContent} />
      <OtherSource onCompose={async (_data, _email) => { composeReqFromOtherSource(_data, _email) }} hideDialog={() => setOtherSource(false)} open={otherSource} toast={toast} />
    </>
  );
}
